export const baseStyles = {
    enableHandle: ({ selected }) => ({
        background: 'white',
        border: '1px solid #1976d2',
        width: '9px',
        height: '9px',
    }),

    disableHandle: ({ selected }) => ({
        // background: selected ? 'white' : 'transparent',
        // border: selected ? '1px solid #1976d2' : 'none',
        background: 'transparent',
        border: 'none',
        width: '9px',
        height: '9px',
        pointerEvents: 'none'
    }),

    enableRootHandle: ({ selected }) => ({
        background: selected ? 'white' : 'white',
        border: selected ? '1px solid #1976d2' : '1px solid #1976d2',
        width: '9px',
        height: '9px'
    }),

    disableRootHandle: ({ selected }) => ({
        // background: selected ? 'white' : 'transparent',
        // border: selected ? '1px solid #1976d2' : 'none',
        background: 'transparent',
        border: 'none',
        width: '9px',
        height: '9px'
    }),
};